import React from "react";
import "./CreditCard.css";
import { formatExpirationDate, getCardDescription } from "../../lib/Money";

const CreditCardV2 = (props) => {

  const card = props.card;
  let brand = getCardDescription(card.get("type"), card.get("cardBrand"));
  return (
    <div className="CreditCard">
      Card: <span className="cardType">{brand}</span>, **** {card.get("cardLast4")}<br/>
      Expires: <span className="cardExpiry">{formatExpirationDate(card.get("cardExpMonth"), card.get("cardExpYear"))}</span>
    </div>
  )

}

export default CreditCardV2;